import {Component, Inject, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {State} from '../../store/reducer/mitarbeiterverwaltung.reducer';
import {RollenverwaltungFormdialogComponent} from '../rollenverwaltung-form-dialog/rollenverwaltung-formdialog.component';
import {RechteItem} from '../../rechte.model';



export interface DialogData {
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  id: number;
  rechte: number[];
  bezeichnung: string;
}


@Component({
  selector: 'app-rollenverwaltung-pageform',
  templateUrl: './rollenverwaltung-pageform.component.html',
  styleUrls: ['./rollenverwaltung-pageform.component.scss'],
})



export class RollenverwaltungPageformComponent{

  public $rollen;
  public $error;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<RollenverwaltungPageformComponent>,
    private store: Store<{ mitarbeiterverwaltung: State }>,
  ) {
    dialogRef.disableClose = true;
    this.$rollen = store.pipe(select((state) => state.mitarbeiterverwaltung.rollen.items));
    this.$error = store.pipe(select((state) => state.mitarbeiterverwaltung.rollen.error));
  }



  public handleSubmitClick(): void{
    this.dialogRef.close(true);
  }

  public addRolle(): void{
    const dialogRef = this.dialog.open(RollenverwaltungFormdialogComponent, {
      data: {
        title: 'pages.rollenverwaltung.addRollen.title',
        submitButtonLabel: 'pages.projektverwaltung.addProjekt.submitButtonLabel',
        cancelButtonLabel: 'pages.projektverwaltung.addProjekt.cancelButtonLabel',
      },
    });
    dialogRef.afterClosed().subscribe();
  }


}

